export default __webpack_public_path__ + "b1086ffcbaa71f11f6cc0115e858b6fd.png";